import React from 'react';
import './SectionHeader.less';

/**
 * SectionHeader — title + optional supporting text on the left, an
 * optional action link on the right. The description is a single
 * short sentence that reads as a caption below the title; do not
 * put paragraphs here.
 */
function SectionHeader({ title, description, action, as = 'h2' }) {
  const Heading = as;
  return (
    <div className="gc-section-header">
      <div className="gc-section-header-text">
        <Heading className="gc-section-header-title">{title}</Heading>
        {description && <p className="gc-section-header-desc">{description}</p>}
      </div>
      {action && <div className="gc-section-header-action">{action}</div>}
    </div>
  );
}

export default SectionHeader;
